import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  getStepIndex,
  useCreateProjectStore,
} from '@/features/projects/create-project/store/use-create-project-store';
import {
  FlowLayout,
  FlowLayoutBody,
} from '@/shared/components/flow/flow-layout';
import { Background } from '@/shared/components/layouts/background';

export const CreateProjectLayout = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { step: currentStep } = useCreateProjectStore();
  const { t } = useTranslation('project', { keyPrefix: 'Shared' });

  const steps = [
    t('create_project_step'),
    t('select_branch_step'),
    t('create_kpis_step'),
    t('add_users_step'),
  ];

  return (
    <Background>
      <FlowLayout
        stepper={{
          steps,
          currentStep: getStepIndex(currentStep) + 1,
        }}
      >
        <FlowLayoutBody>{children}</FlowLayoutBody>
      </FlowLayout>
    </Background>
  );
};
